import { FeedItemDto } from "generated/CoreApi_v1";
import { CardOwnPropsOptions } from "views/knowledge/components/card";
import FeedItemHelper from "views/knowledge/components/card/FeedItemHelper";
import { CardVideoSearchData } from "./CardEvents";

export const PrepareCardOwnProps = (pub: FeedItemDto, helper: FeedItemHelper, search?: CardVideoSearchData): CardOwnPropsOptions => {
    return {
        publicationId: pub.publicationId,
        presentation: {
            autoplay: helper.hasAutoPlayPresentation,
            lighboxOpened: false,
            currentIsVideo: null,
            currentAttachId: null
        },
        search: search
    } as CardOwnPropsOptions;
};
